import doMetric from '../tracking/bigQueryMetricRecorder';
import attributes from '../tracking/attributes';
import Track from '../utils/tracking';

function packAttribute(attributeName, attributeValue) {
  return [attributes.getAttribute(attributeName, attributeValue)];
}

export function initClarusElementTracking() {
  try {
    let elementList = document.getElementsByClassName('clarus-banner');
    if (elementList.length > 0) {
      const clarusDesktopBanner = elementList[0];
      clarusDesktopBanner.addEventListener('click', () => {
        doMetric('clickClarusAdvert', packAttribute('componentName', 'clarus desktop banner'));
      });
    }
  
    const clarusDesktopPopup = document.querySelector('#clarus-script-container-popup-desktop');
    if (clarusDesktopPopup != null) {
      clarusDesktopPopup.addEventListener('click', () => {
        doMetric('clickClarusAdvert', packAttribute('componentName', 'clarus desktop popup'));
      });
    }
  
    elementList = document.getElementsByClassName('clarus-banner-mobile');
  
    if (elementList.length > 0) {
      const clarusMobileBanner = elementList[0];
      clarusMobileBanner.addEventListener('click', () => {
        doMetric('clickClarusAdvert', packAttribute('componentName', 'clarus mobile banner'));
      });
    }
  
    const clarusMobilePopup = document.querySelector('#clarus-script-container-popup-mobile');
    if (clarusMobilePopup != null) {
      clarusMobilePopup.addEventListener('click', () => {
        doMetric('clickClarusAdvert', packAttribute('componentName', 'clarus mobile popup'));
      });
    }
  
    const clarusBanners = document.querySelectorAll('[alt=\'Advertisement\']');
    if (clarusBanners.length !== 0) { // No adblock
      for (const clarusBanner of clarusBanners) {
        clarusBanner.onerror = () => Track.track('Clarus unable to load advert image');
      }
    }
  } catch (error) {
    Track.track(error);
  }
}
